<template>
  <create-account-layout
    :current-step="3"
    title="Join this Carrier"
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <p class="my-6 text-left text-sm text-dark-gray">
          Send a verification code using one of the contact methods below to
          verify you belong to this carrier.
        </p>
        <template v-if="contacts.length > 0">
          <round-radio-button
            v-for="(contact, index) in filteredContacts"
            :key="index"
            :class="
              company_verification_method?.id === contact.id
                ? 'radio-class mb-2 w-full'
                : 'radio-class mb-2 w-full border-white'
            "
            :item="formatContactType(contact.channel, contact.value)"
            :value="contact.channel"
            name="company_verification_type"
            :handle-click="() => handleRadioClick(contact)"
            :checked="company_verification_method?.id === contact.id"
          />
        </template>
        <p
          v-if="!fmscaIsEmpty && contacts.length > 3"
          class="cursor-pointer text-left text-yellow-500 underline"
          @click="seeMore = !seeMore"
        >
          {{ seeMore ? 'See Less' : 'See More' }}
        </p>

        <NotFMSCABox
          v-else-if="fmscaIsEmpty && !contacts.length && !isViewLoading"
        >
          No secure FMCSA contact methods found. Please call us at 906-HIGHWAY
          or email us at service@highway.com for further assistance.
        </NotFMSCABox>
        <div
          v-else-if="fmscaIsEmpty && !contacts.length && isViewLoading"
          class="mt-5"
        >
          <FMSCA-loading-item
            v-for="n in 3"
            :key="n"
          />
        </div>
        <button-main
          class="mb-4 mt-3"
          :disabled="
            !(
              full_name &&
              email_address &&
              company_verification_method.id &&
              !fmscaIsEmpty
            ) || !!(full_name_error || email_address_error)
          "
          type="submit"
          :loading-spinner="isButtonLoading"
          value="Continue"
        />
        <!-- <p class="text-dark-gray"> Don't have access to these contact methods?</p>
        <button-main
          class="mb-4 text-yellow-500"
          variant="link"
          @click="handleNotAccessClick"
        >
          Request Access
        </button-main> -->
      </div>
    </form>
  </create-account-layout>
  <verify-account
    v-if="showVerifyAccountModal"
    :visible="openVerifyAccountModal"
    @close="onCloseVerifyAccountModal"
  />
</template>

<script>
import _ from 'lodash';

import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import FMSCALoadingItem from '@/views/signup/FMSCALoadingItem.vue';

// Common
import { toastResponse } from '@/common/handleServerResponse';

//Mixin
import fmcsaContacs from '@/mixins/fmcsaContacs';

import VerifyAccount from '@/components/modals/VerifyAccount.vue';
import NotFMSCABox from '@/components/NotFMSCABox.vue';

export default {
  name: 'FMSCAContacts',
  components: {
    CreateAccountLayout,
    ButtonMain,
    RoundRadioButton,
    VerifyAccount,
    NotFMSCABox,
    FMSCALoadingItem,
  },
  mixins: [fmcsaContacs],
  data() {
    return {
      isViewLoading: true,
      isButtonLoading: false,
      company_verification_method: {},
      seeMore: false,
      showVerifyAccountModal: false,
      full_name_error: '',
      email_address_error: '',
    };
  },
  computed: {
    filteredContacts: function () {
      let contacts = this.seeMore ? this.contacts : this.contacts?.slice(0, 3);

      const hasEmailContacts = this.contacts?.some(
        (el) => el.channel === 'email'
      );

      if (hasEmailContacts) {
        return [
          ...contacts,
          {
            id: 290799,
            value: "I don't have access to these contact methods",
            channel: 'plainText',
          },
        ];
      }

      return contacts;
    },
    fmscaIsEmpty() {
      return !this.contacts.length;
    },
    first_name() {
      return this.$store.state.users?.currentUser?.first_name;
    },
    last_name() {
      return this.$store.state.users.currentUser.last_name;
    },
    full_name() {
      return this.first_name + ' ' + this.last_name;
    },
    email_address() {
      return this.$store.state.users.currentUser.email;
    },
    isLinkDisable() {
      return (
        !(this.full_name && this.email_address) ||
        this.fmscaIsEmpty ||
        !_.isEmpty(this.company_verification_method)
      );
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('users/refreshCurrentUser');
      let currentUser = this.$store.state.users.currentUser;
      // Redirect to the home page if the user is already associated with a company
      // unless the user's company is a broker that is still in the process
      // of claiming a carrier
      if (
        currentUser.company?.id &&
        !(
          currentUser?.company?.company_type == 'broker' &&
          !currentUser?.company?.carrier_id
        )
      ) {
        this.$router.push({ name: 'Home' });
      } else if (!currentUser.email || !currentUser.first_name) {
        this.$router.push({ name: 'GeneralInformation' });
      } else {
        await this.getFMCSAContacts();
      }
    } catch (error) {
      console.error('ERROR:', error);
    }
    this.isViewLoading = false;
  },
  methods: {
    //  filterCensusData(data) {
    //   return data?.filter(item => item?.is_type === "census" || item?.is_type === "census_cell" || item?.is_type === "census_main");
    // },

    onCloseVerifyAccountModal() {
      this.showVerifyAccountModal = false;
    },
    openVerifyAccountModal() {
      this.showVerifyAccountModal = true;
    },
    doesThUserHaveAccessToThePhoneNumber() {
      const emailItem = this.contacts.find(
        (contact) => contact.channel === 'email'
      );
      const phoneItem = this.contacts.find(
        (contact) => contact.channel === 'call'
      );
      // TODO make a refactor for this part. It is pending the part to show if there is not FMCS contact info
      if (emailItem || !phoneItem) return true;
      if (_.isEmpty(this.company_verification_method)) return false;
      return true;
    },
    async handleNotAccessClick() {
      if (this.full_name && this.email_address) {
        if (!this.doesThUserHaveAccessToThePhoneNumber()) {
          this.openVerifyAccountModal();
          return;
        }

        this.$router.push({
          name: 'RequestAccessFMSCA',
          params: { canMoveOn: true },
        });
      }
    },
    formatContactType(type, value) {
      if (type === 'plainText') return value;

      return type === 'call' ? `Call ${value}` : `Email ${value}`;
    },
    handleRadioClick(item) {
      if (
        this.company_verification_method &&
        item.id === this.company_verification_method.id
      ) {
        this.company_verification_method = {};
        return;
      }
      const companyToVerify = {
        ...item,
        type: item.phone_e164 ? 'call' : 'email',
      };
      this.company_verification_method = companyToVerify;
    },
    async handleSubmit() {
      if (this.company_verification_method?.channel === 'plainText') {
        this.handleNotAccessClick();
        return;
      }

      this.isButtonLoading = true;
      const verificationRes = await this.$store.dispatch(
        'carriers/carrierVerification',
        {
          endpoint_id: this.company_verification_method.id, // get from this.data.company
          channel: this.company_verification_method.type,
        }
      );

      if ([200, 201].includes(verificationRes.status)) {
        // send user to account success screen
        this.$router.push({
          name: 'AccountVerification',
          params: { canMoveOn: true },
        });
      } else {
        toastResponse(this, verificationRes, null);
      }

      this.isButtonLoading = false;
    },
  },
};
</script>

<style>
.radio-class {
  @apply border-white;
}
.radio-class > label {
  @apply rounded-md bg-white;
}

.radio-class > label > .checkmark {
  @apply bg-off-white;
}
</style>
